import React, { cloneElement, ReactElement, Ref, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

type CSSTransitionProps = React.ComponentProps<typeof CSSTransition>;

const TransitionWithRef = ({
    children,
    ...props
}: Omit<CSSTransitionProps, 'nodeRef'> & { children: ReactElement }) => {
    const nodeRef = useRef<HTMLElement>(null);
    const transitionProps = { ...props, nodeRef } as CSSTransitionProps;
    return (
        <CSSTransition {...transitionProps}>
            {cloneElement(children, { ref: nodeRef } as { ref: Ref<HTMLElement> })}
        </CSSTransition>
    );
};

export default TransitionWithRef;
